module.exports = __webpack_public_path__ + "img/es-ct.b9b4d626.svg";